import jpex from 'jpex';

export default () => {
  jpex.constant<Window>(window);
};
